module.exports = __webpack_public_path__ + "static/dove-52bfa9d6ec24cca3aa8e49cba6aa0bd5.svg";